import { useEffect, useState } from "react";
import Select from "react-select";
import { Switch } from "@headlessui/react";
import InputField from "../../atoms/InputField";
import SubHeading from "../../atoms/SubHeading";
import { GET_USER_ROLE } from "../../../api/apiUsers";
import CreateInquilino from "../../organisms/inmueble/inmuebleDocsTables/CreateInquilino";
import DatosDeFacturacion from "../../organisms/inmueble/DatosDeFacturacion";

const RentaSection = ({ values, setFieldValue, setArchivosRenta }) => {
    const [loading, setLoading] = useState(true);
    const [residentes, setResidentes] = useState();

    const rentaFiles = [
        { name: "contrato_renta", label: "Contrato de renta" },
        { name: "ine_inquilino", label: "INE del inquilino (Opcional)" },
    ];

    const avalFiles = [
        { name: "ine_aval", label: "INE del Aval" },
        { name: "comprobante_aval", label: "Comprobante de domicilio del Aval" },
    ];

    const getResidentes = async () => {
        try {
            const residentesData = await GET_USER_ROLE("Resident");
            setResidentes(residentesData);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getResidentes();
    }, []);

    return (
        <div className="w-full flex flex-col border border-gray-500 bg-gray-100 p-4 rounded-md">
            <div className="w-full flex flex-row justify-between">
                <SubHeading text="Rentado" color="black" />
                <Switch
                    checked={values.isRented}
                    onChange={(value) => setFieldValue("isRented", value)}
                    className={`${values.isRented ? 'bg-rs-azul' : 'bg-gray-500'} relative inline-flex h-6 w-11 items-center rounded-full transition`}
                >
                <span className={`${values.isRented ? 'translate-x-6' : 'translate-x-1'} inline-block h-4 w-4 transform rounded-full bg-white transition`} />
                </Switch>
            </div>
            {values.isRented && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {rentaFiles.map(({ name, label }) => (
                    <InputField
                        key={name}
                        name={name}
                        label={label}
                        type="file"
                        onChange={(e) => {
                            const file = e.currentTarget.files?.[0] || null;
                            setFieldValue(name, file);
                            setArchivosRenta((prev) => ({ ...prev, [name]: file }));
                        }}
                    />
                ))}
                <div className="flex flex-row gap-2">
                    <InputField name="subtotal" label="Subtotal" type="number" placeholder="$"/>
                    <InputField name="iva" label="IVA" type="number" placeholder="$"/>
                    <InputField name="monto" label="Renta total" type="number" placeholder="$"/>
                </div>
                <InputField name="date_start" label="Fecha de inicio del contrato" type="date" />
                <InputField name="date_end" label="Fecha de fin del contrato" type="date" />
                <div className="flex flex-col">
                    <label className="text-rs-azul font-bold">Inquilino</label>
                    <Select
                        options={residentes?.map((res) => ({ value: res.id, label: `${res.name} (${res.email})` }))}
                        isClearable
                        isLoading={loading}
                        onChange={(selected) => setFieldValue("userId", selected?.value || null)}
                        placeholder="Selecciona un inquilino"
                        className="border border-blue-600 rounded-md"
                        classNamePrefix="select"
                        value={ residentes?.map((res) => ({ value: res.id, label: `${res.name} (${res.email})` })).find((option) => option.value === values.userId) || null }
                        isDisabled={values.create}
                    />
                    <button
                        type="button"
                        onClick={() => {
                            const newValue = !values.create;
                            setFieldValue("create", newValue);
                            if (newValue) {
                                setFieldValue("userId", null);
                            }
                        }}
                        className="mt-1 px-4 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700 transition"
                    >
                        {!values.create ? "Crear inquilino" : "Seleccionar de la lista"}
                    </button>
                </div>
                {values.create &&
                    <CreateInquilino/>
                }
                <DatosDeFacturacion/>
                <div className="flex flex-col">
                    <label className="text-rs-azul font-bold">Tipo de garantía</label>
                    <button
                        type="button"
                        className="px-6 py-1 w-fit rounded-lg transition-colors duration-300 bg-blue-600 text-white "
                        onClick={(value) => setFieldValue("isAval", !values.isAval)}
                    >
                        {values.isAval ? 'Aval' : 'Poliza juridica'}
                    </button>
                </div>
                {values.isAval ?
                    <>
                        {avalFiles.map(({ name, label }) => (
                            <InputField
                                key={name}
                                name={name}
                                label={label}
                                type="file"
                                onChange={(e) => {
                                    const file = e.currentTarget.files?.[0] || null;
                                    setFieldValue(name, file);
                                    setArchivosRenta((prev) => ({ ...prev, [name]: file }));
                                }}
                            />
                        ))}
                    </>
                :
                    <InputField
                        name="poliza_juridica"
                        label="Poliza juridica"
                        type="file"
                        onChange={(e) => {
                            const file = e.currentTarget.files?.[0] || null;
                            setFieldValue("poliza_juridica", file);
                            setArchivosRenta((prev) => ({ ...prev, poliza_juridica: file }));
                        }}
                    />
                }
            </div>
            )}
        </div>
    );
};

export default RentaSection;